import { IconButton, Stack, Typography } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import type { ReactNode } from 'react';
import { VyTooltip } from '../../../../../../../components/new-design/VyTooltip';

export const createInfoTooltipAddon = (title: string, subtitle: string): (() => ReactNode) => {
  return () => (
    <VyTooltip
      tooltipContent={
        <Stack spacing={0.5}>
          <Typography variant="body2" sx={{ fontSize: '11px' }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" sx={{ fontSize: '11px' }}>
              {subtitle}
            </Typography>
          )}
        </Stack>
      }
    >
      <IconButton>
        <VyIcon icon="Info" />
      </IconButton>
    </VyTooltip>
  );
};
